export default __webpack_public_path__ + "static/media/logo.fc8bf276.png";